export default "/wp-content/themes/oportun/dist/assets/brand/Outreach_Color-89a613a61444b235.svg"